import { InboxPage_GetFeatureFlagsQuery, useInboxPage_GetFeatureFlagsQuery } from '../types/GraphqlTypes';
import stringUtils from '../utils/stringUtils';
import { useRouter } from 'next/router';
import apolloClient from '../lib/apollo';

type FeatureFlagsQueryResponse = InboxPage_GetFeatureFlagsQuery['getFeatureFlags'];

/**
 * @returns Available feature flags and whether or not they are enabled
 * @description Handles logic to determine if the feature flag is enabled by a param in the URL or set in the app config
 *      A feature flag can be enabled in the browser by setting the flag name as a param in the url with the value of `true`
 *      or set for all users in the app config
 */
export default () => {
  const { data: featureFlagsData } = useInboxPage_GetFeatureFlagsQuery({
    fetchPolicy: 'cache-first',
    client: apolloClient,
  });
  const router = useRouter();
  const featureFlags = featureFlagsData?.getFeatureFlags || {};

  return (
    Object.keys(featureFlags).reduce((accum, flag) => {
      const featureFlagParam = flag as keyof FeatureFlagsQueryResponse;
      const featureFlagValue = featureFlags[featureFlagParam];
      const shouldShowFeatureFlagQueryParamValue = router.query[featureFlagParam]?.toString() || '';

      return {
        ...accum,
        [flag]: featureFlagValue || stringUtils.isTrue(shouldShowFeatureFlagQueryParamValue),
      };
    }, {} as FeatureFlagsQueryResponse) || {}
  );
};
